<script setup lang="ts">
withDefaults(
  defineProps<{
    tag?: 'label' | 'p' | (string & {})
    text?: string
    htmlFor?: string
    error?: string
  }>(),
  {
    tag: `label`,
  },
);

// NOTE: needed to wrap with a <div> for rendering hydration issues mismatch
</script>

<template>
  <div
    class="group-has-[input:focus]:text-neutral-10"
    :class="{ 'text-error': !!error }"
  >
    <component
      :is="tag"
      :for="tag === `label` ? htmlFor : undefined"
      class="inline-block empty:hidden pb-xs font-medium"
    >
      {{ text }}
    </component>
  </div>
</template>
